import axios from "axios";
import { getClientID, getURL } from "../redux/selectors";
import store from "../redux/store";

const getWebMenu = async ({ user, menuname }) => {
  const state = store.getState();
  const url = getURL(state);
  const clientID = getClientID(state);

  return await axios
    .post(`${process.env.REACT_APP_BACKEND_DOMAIN}/d1services`, {
      url,
      data: {
        service: "getWebMenu",
        clientID,
        format: 2,
        menuname,
        user,
        appID: process.env.REACT_APP_SOFTONE_APPID,
      },
    })
    .then((res) => res.data)
    .catch((er) => ({ success: false, error: er.message }));
};

export default getWebMenu;
